// src/components/table/OperatorAbos.tsx

import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'
import { useEffect, useState } from 'react'

import { FolderName, FolderPool } from '@/types/domain/folder'
import { SensorPool } from '@/types/domain/sensor'

import {
  OperatorData,
  useFolderPool,
  useOperator,
  useSensorPool,
} from '../../hooks'

export const OperatorAbos = () => {
  const opData: OperatorData = useOperator()
  const fPool: FolderPool = useFolderPool()
  const sPool: SensorPool = useSensorPool()

  const [data, setData] = useState([])

  useEffect(() => {
    if (!opData?.reports) return
    setData(opData?.reports)
  }, [opData?.reports])

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Gebäude</TableCell>

            <TableCell>Sensorname</TableCell>

            <TableCell>Empfänger</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {data.map(report => {
            const folder = fPool.find(f => Number(f.id) === report.folder_id)
            const fName: FolderName =
              folder?.attributes.name ?? String(report.folder_id)

            return (
              <TableRow key={fName}>
                <TableCell sx={{ verticalAlign: 'top' }}>{fName}</TableCell>

                <TableCell sx={{ verticalAlign: 'top' }}>
                  {report.sensor_ids.split(',').map(item => {
                    const sensor = sPool.find(
                      f => Number(f.id) === Number(item)
                    )
                    const sensorName = sensor?.attributes.name ?? String(item)

                    return (
                      <Box key={item}>
                        {sensorName}
                        <br />
                      </Box>
                    )
                  })}
                </TableCell>

                <TableCell sx={{ verticalAlign: 'top' }}>
                  {report.mailto.split(',').map(item => (
                    <Box key={item}>
                      {item}
                      <br />
                    </Box>
                  ))}
                </TableCell>
              </TableRow>
            )
          })}

          {data.length === 0 && (
            <TableRow>
              <TableCell align={'center'} colSpan={3}>
                Kein Berichte abonniert.
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
